const e=e=>""+(e?`${e},`:"1"),o=({latitude:o,longitude:t,name:a})=>({searchUrl:`https://maps.google.com/maps/search/${encodeURI(a||"")}/@${e(o)}${e(t)}17z`});export{o as getStaticMapProps};
//# sourceMappingURL=getStaticMapUrl.js.map
